module.exports = __webpack_public_path__ + "static/media/New Customer.f483539c.svg";